(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["track-order-17track"] && !Shopify.designMode) return;
  try {
    const bindTrackOrderForms = (root = document) => {
    root.querySelectorAll('[data-mf-track-form]').forEach((form) => {
      if (form.dataset.mfTrackBound === 'true') return;
      form.dataset.mfTrackBound = 'true';
      const input = form.querySelector('[data-mf-track-input]');
      const error = form.querySelector('[data-mf-track-error]');
      if (!input || !error) return;

      const clearError = () => {
        input.removeAttribute('aria-invalid');
        error.hidden = true;
      };

      input.addEventListener('input', clearError);
      input.addEventListener('invalid', () => {
        input.setAttribute('aria-invalid', 'true');
        error.hidden = false;
      });
      form.addEventListener('submit', (event) => {
        input.value = input.value.trim();
        if (!input.checkValidity()) {
          event.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          error.hidden = false;
          input.focus();
          return;
        }
        clearError();
      });
    });
  };

  bindTrackOrderForms();
  document.addEventListener('shopify:section:load', (event) => bindTrackOrderForms(event.target));
  } catch(e) { console.error(e); }
})();

})();
